import { type EnumType } from '../models/EnumType';

export enum PersonType {
  LEGAL = 'Pessoa jurídica',
  PHYSICAL = 'Pessoa física',
}

export const personTypeOptions = [
  { value: 'LEGAL', label: 'Pessoa jurídica' },
  { value: 'PHYSICAL', label: 'Pessoa física' },
];

export function toEnumType(personType: PersonType): EnumType {
  const key = Object.keys(PersonType).find((k) => PersonType[k as keyof typeof PersonType] === personType);
  return {
    value: key || '',
    description: personType,
  };
}
